import { usePlatform } from '../context/PlatformContext'
import { brandThemes, type BrandId } from '../data/brandThemes'
import { brandContent } from '../data/brandContent'

/**
 * useBrand — the one place a component learns which platform it's on.
 *
 * Returns the active brand's appearance tokens (`theme`) and copy/routes
 * (`content`). Components render LitLaunch's structure and plug these values
 * in, instead of branching on the platform themselves.
 *
 * `isAfterTide` is still exposed for genuine BEHAVIOUR differences only — the
 * 18+ age gate and content filtering — never for colour or copy.
 */
export const useBrand = () => {
  const { isAfterTide } = usePlatform()
  const id: BrandId = isAfterTide ? 'aftertide' : 'litlaunch'
  return {
    id,
    theme: brandThemes[id],
    content: brandContent[id],
    isAfterTide,
  }
}

export default useBrand
